import SubcategoryPage from '@/components/template/SubcategoryPage';

const BiboScala = () => {
  const products = [
    {
      title: "Bibò Scala Classic",
      imageSrc: "https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&q=80",
      url: "/proizvodi/bibo-scala-classic"
    },
    {
      title: "Bibò Scala Modern",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/bibo-scala-modern"
    },
    {
      title: "Bibò Scala Premium",
      imageSrc: "https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/bibo-scala-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Bibò Scala"
      description="Elegantne lestve Bibò Scala, ki združujejo funkcionalnost in estetiko za sodoben dom."
      heroImage="https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default BiboScala;